export default "__VITE_ASSET__DV90AVSa__"